/* tslint:disable */
/* eslint-disable */
/**
 * SENGO Platform Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.27
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateDashboardProfileRequest } from '../model';
// @ts-ignore
import type { CreateDashboardProfileResponse } from '../model';
// @ts-ignore
import type { DashboardProfile } from '../model';
// @ts-ignore
import type { DashboardProfilesList } from '../model';
// @ts-ignore
import type { DashboardRolesList } from '../model';
// @ts-ignore
import type { PasswordResetRequest } from '../model';
// @ts-ignore
import type { UpdateDashboardProfileRequest } from '../model';
/**
 * DashboardRolesApi - axios parameter creator
 */
export const DashboardRolesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Request the password reset link
         * @param {PasswordResetRequest} passwordResetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminResetPassword: async (passwordResetRequest: PasswordResetRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordResetRequest' is not null or undefined
            assertParamExists('adminResetPassword', 'passwordResetRequest', passwordResetRequest)
            const localVarPath = `/admin/dashboard/profile/reset/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordResetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new dashboard profile
         * @param {CreateDashboardProfileRequest} createDashboardProfileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDashboardProfile: async (createDashboardProfileRequest: CreateDashboardProfileRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDashboardProfileRequest' is not null or undefined
            assertParamExists('createDashboardProfile', 'createDashboardProfileRequest', createDashboardProfileRequest)
            const localVarPath = `/admin/dashboard/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDashboardProfileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete the dashboard profile
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDashboardProfile: async (profileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('deleteDashboardProfile', 'profileId', profileId)
            const localVarPath = `/admin/dashboard/profile/{profileId}`
                .replace('{profileId}', encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the dashboard profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardProfile: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/dashboard/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the specified dashboard profile
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardProfileById: async (profileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('getDashboardProfileById', 'profileId', profileId)
            const localVarPath = `/admin/dashboard/profile/{profileId}`
                .replace('{profileId}', encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all the dashboard profiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardProfiles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/dashboard/profiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all the dashboard roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardRoles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/dashboard/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update dashboard profile
         * @param {string} profileId 
         * @param {UpdateDashboardProfileRequest} updateDashboardProfileRequest Updated dashboard profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDashboardProfile: async (profileId: string, updateDashboardProfileRequest: UpdateDashboardProfileRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('updateDashboardProfile', 'profileId', profileId)
            // verify required parameter 'updateDashboardProfileRequest' is not null or undefined
            assertParamExists('updateDashboardProfile', 'updateDashboardProfileRequest', updateDashboardProfileRequest)
            const localVarPath = `/admin/dashboard/profile/{profileId}`
                .replace('{profileId}', encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDashboardProfileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardRolesApi - functional programming interface
 */
export const DashboardRolesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardRolesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Request the password reset link
         * @param {PasswordResetRequest} passwordResetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminResetPassword(passwordResetRequest: PasswordResetRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminResetPassword(passwordResetRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardRolesApi.adminResetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new dashboard profile
         * @param {CreateDashboardProfileRequest} createDashboardProfileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDashboardProfile(createDashboardProfileRequest: CreateDashboardProfileRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateDashboardProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDashboardProfile(createDashboardProfileRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardRolesApi.createDashboardProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete the dashboard profile
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDashboardProfile(profileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDashboardProfile(profileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardRolesApi.deleteDashboardProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the dashboard profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardProfile(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardProfile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardProfile(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardRolesApi.getDashboardProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the specified dashboard profile
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardProfileById(profileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardProfile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardProfileById(profileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardRolesApi.getDashboardProfileById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all the dashboard profiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardProfiles(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardProfilesList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardProfiles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardRolesApi.getDashboardProfiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all the dashboard roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardRoles(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardRolesList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardRoles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardRolesApi.getDashboardRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update dashboard profile
         * @param {string} profileId 
         * @param {UpdateDashboardProfileRequest} updateDashboardProfileRequest Updated dashboard profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDashboardProfile(profileId: string, updateDashboardProfileRequest: UpdateDashboardProfileRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardProfile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDashboardProfile(profileId, updateDashboardProfileRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardRolesApi.updateDashboardProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DashboardRolesApi - factory interface
 */
export const DashboardRolesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardRolesApiFp(configuration)
    return {
        /**
         * 
         * @summary Request the password reset link
         * @param {PasswordResetRequest} passwordResetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminResetPassword(passwordResetRequest: PasswordResetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminResetPassword(passwordResetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new dashboard profile
         * @param {CreateDashboardProfileRequest} createDashboardProfileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDashboardProfile(createDashboardProfileRequest: CreateDashboardProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateDashboardProfileResponse> {
            return localVarFp.createDashboardProfile(createDashboardProfileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete the dashboard profile
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDashboardProfile(profileId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDashboardProfile(profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the dashboard profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardProfile(options?: RawAxiosRequestConfig): AxiosPromise<DashboardProfile> {
            return localVarFp.getDashboardProfile(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the specified dashboard profile
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardProfileById(profileId: string, options?: RawAxiosRequestConfig): AxiosPromise<DashboardProfile> {
            return localVarFp.getDashboardProfileById(profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all the dashboard profiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardProfiles(options?: RawAxiosRequestConfig): AxiosPromise<DashboardProfilesList> {
            return localVarFp.getDashboardProfiles(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all the dashboard roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardRoles(options?: RawAxiosRequestConfig): AxiosPromise<DashboardRolesList> {
            return localVarFp.getDashboardRoles(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update dashboard profile
         * @param {string} profileId 
         * @param {UpdateDashboardProfileRequest} updateDashboardProfileRequest Updated dashboard profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDashboardProfile(profileId: string, updateDashboardProfileRequest: UpdateDashboardProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardProfile> {
            return localVarFp.updateDashboardProfile(profileId, updateDashboardProfileRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardRolesApi - interface
 */
export interface DashboardRolesApiInterface {
    /**
     * 
     * @summary Request the password reset link
     * @param {PasswordResetRequest} passwordResetRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminResetPassword(passwordResetRequest: PasswordResetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Create a new dashboard profile
     * @param {CreateDashboardProfileRequest} createDashboardProfileRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createDashboardProfile(createDashboardProfileRequest: CreateDashboardProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateDashboardProfileResponse>;

    /**
     * 
     * @summary Delete the dashboard profile
     * @param {string} profileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteDashboardProfile(profileId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get the dashboard profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDashboardProfile(options?: RawAxiosRequestConfig): AxiosPromise<DashboardProfile>;

    /**
     * 
     * @summary Get the specified dashboard profile
     * @param {string} profileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDashboardProfileById(profileId: string, options?: RawAxiosRequestConfig): AxiosPromise<DashboardProfile>;

    /**
     * 
     * @summary Get all the dashboard profiles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDashboardProfiles(options?: RawAxiosRequestConfig): AxiosPromise<DashboardProfilesList>;

    /**
     * 
     * @summary Get all the dashboard roles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDashboardRoles(options?: RawAxiosRequestConfig): AxiosPromise<DashboardRolesList>;

    /**
     * 
     * @summary Update dashboard profile
     * @param {string} profileId 
     * @param {UpdateDashboardProfileRequest} updateDashboardProfileRequest Updated dashboard profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateDashboardProfile(profileId: string, updateDashboardProfileRequest: UpdateDashboardProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardProfile>;

}

/**
 * DashboardRolesApi - object-oriented interface
 */
export class DashboardRolesApi extends BaseAPI implements DashboardRolesApiInterface {
    /**
     * 
     * @summary Request the password reset link
     * @param {PasswordResetRequest} passwordResetRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminResetPassword(passwordResetRequest: PasswordResetRequest, options?: RawAxiosRequestConfig) {
        return DashboardRolesApiFp(this.configuration).adminResetPassword(passwordResetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new dashboard profile
     * @param {CreateDashboardProfileRequest} createDashboardProfileRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createDashboardProfile(createDashboardProfileRequest: CreateDashboardProfileRequest, options?: RawAxiosRequestConfig) {
        return DashboardRolesApiFp(this.configuration).createDashboardProfile(createDashboardProfileRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete the dashboard profile
     * @param {string} profileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteDashboardProfile(profileId: string, options?: RawAxiosRequestConfig) {
        return DashboardRolesApiFp(this.configuration).deleteDashboardProfile(profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the dashboard profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDashboardProfile(options?: RawAxiosRequestConfig) {
        return DashboardRolesApiFp(this.configuration).getDashboardProfile(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the specified dashboard profile
     * @param {string} profileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDashboardProfileById(profileId: string, options?: RawAxiosRequestConfig) {
        return DashboardRolesApiFp(this.configuration).getDashboardProfileById(profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all the dashboard profiles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDashboardProfiles(options?: RawAxiosRequestConfig) {
        return DashboardRolesApiFp(this.configuration).getDashboardProfiles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all the dashboard roles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDashboardRoles(options?: RawAxiosRequestConfig) {
        return DashboardRolesApiFp(this.configuration).getDashboardRoles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update dashboard profile
     * @param {string} profileId 
     * @param {UpdateDashboardProfileRequest} updateDashboardProfileRequest Updated dashboard profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateDashboardProfile(profileId: string, updateDashboardProfileRequest: UpdateDashboardProfileRequest, options?: RawAxiosRequestConfig) {
        return DashboardRolesApiFp(this.configuration).updateDashboardProfile(profileId, updateDashboardProfileRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

